import React from 'react';
import {
  List,
  Datagrid,
  TextField,
  DateField,
  NumberField,
  EditButton,
  Filter,
  SearchInput,
  SimpleList,
} from 'react-admin';
import { useMediaQuery } from '@material-ui/core';

const CustomerFilter = (props: any) => (
  <Filter {...props} variant="outlined">
    <SearchInput label="Code" source="code~like" alwaysOn />
    <SearchInput label="Customer Name" source="customerName~like" alwaysOn />
    <SearchInput label="Mobile" source="mobileNo~like" alwaysOn />
  </Filter>
);

export const CustomerList = (props: any) => {
  const propsObj: any = { ...props };
  const isSmall = useMediaQuery((theme: any) => theme.breakpoints.down('sm'));

  if (propsObj.permissions) {
    const resourcename = `/${props.resource}`;
    const myPermissions = propsObj.permissions.filter((item: any) => item.NavigateUrl.toLowerCase().trim() === resourcename);
    if (myPermissions.length > 0) {
      const p = myPermissions[0];
      propsObj.hasList = p.View === 1;
      propsObj.hasShow = p.View === 1;
      propsObj.hasEdit = p.Edit === 1;
      propsObj.hasDelete = p.Delete === 1;
      propsObj.hasCreate = p.Create === 1;
      propsObj.hasExport = p.Export === 1;
    }
  }

  return (
    <React.Fragment>
      <List
        {...propsObj}
        exporter={propsObj.hasExport}
        bulkActionButtons={false}
        title="Customers"
        filters={<CustomerFilter />}
      >
        {isSmall ? (
          <SimpleList
            primaryText={(record: any) => `${record.code || ''} - ${record.customerName || ''}`}
            secondaryText={(record: any) => record.mobileNo || ''}
            // tertiaryText={(record: any) =>
            //   record.createdDate ? `Created: ${new Date(record.createdDate).toLocaleDateString()}` : ''
            // }
            linkType={propsObj.hasEdit ? 'edit' : 'show'}
          />
        ) : (
          <Datagrid rowClick={propsObj.hasEdit ? 'edit' : undefined}>
            {propsObj.hasEdit && <EditButton />}
            <TextField source="code" label="Code" />
            <TextField source="customerName" label="Customer Name" />
            <TextField source="mobileNo" label="Mobile" />
            <TextField source="state" label="State" />
            <TextField source="pincode" label="Pincode" />
            {/* <DateField source="createdDate" label="Created Date" locales="fr-FR" />
            <DateField source="modifyDate" label="Updated Date" locales="fr-FR" /> */}
          </Datagrid>
        )}
      </List>
    </React.Fragment>
  );
};
